import React from 'react';
import Post from '../components/Post';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import client from '../utils/cms';


const Home = () => {

    const [posts, setPosts] = React.useState([]);

    useEffect(() => {
        //const posts = client.collection('posts');
        
          const fetchData = async () => {
            try {
                const result = await client.fetch('posts?populate=thumbnail&sort=createdAt:desc');
                const data = await result.json();
                setPosts(data.data);
            } catch (error) {
                console.error('Error fetching posts:', error);
            }
        }

        fetchData();

    }, []);


    useEffect(() => {
        // Function to set visible class for elements in viewport
        const setInitialVisible = () => {
            const elements = document.querySelectorAll('.fade-in');
            elements.forEach((el) => {
                const rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom >= 0) {
                    el.classList.add('visible');
                } else {
                    el.classList.remove('visible');
                }
            });
        };

        // Function to fade in elements as they enter viewport on scroll
        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in');
            elements.forEach((el) => {
                if (!el.classList.contains('visible')) {
                    const rect = el.getBoundingClientRect();
                    if (rect.top < window.innerHeight && rect.bottom >= 0) {
                        el.classList.add('visible');
                    }
                }
            });
        };

        // Run after posts are rendered
        setTimeout(setInitialVisible, 0);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [posts]);

    return (
        <>
            <div className="text-center mb-[36px]">
                    <h1 className="text-lg sm:text-2xl  mb-[18px] font-bold"> Le Kink </h1>
                    <p className="text-base sm:text-base mt-1"> Sofia | I like when things get weird  </p>
            </div>

            <main className="mt-[26px] z-0 relative">

                    {posts?.map((post, index) => (
                            <div
                                    key={post.id || index}
                                    className={`mb-[36px] fade-in${index === 0 ? ' visible' : ''}`}
                                    style={{ transitionDelay: '0s' }}
                            >
                                    <Link to={`/post/${post.slug}`}>
                                            <Post version="short" data={post}/>
                                    </Link>
                            </div>
                    ))}

            </main>

            <style>
                {`
                    .fade-in {
                            opacity: 0;
                            transform: translateY(40px);
                            transition: opacity 1s cubic-bezier(0.25, 0.1, 0.25, 1), transform 1s cubic-bezier(0.25, 0.1, 0.25, 1);
                    }
                    .fade-in.visible {
                            opacity: 1;
                            transform: translateY(0);
                    }
                `}
            </style>
        </>
    );
};


export default Home;

